export const meta = {
  docsLink: 'https://mantine.dev',
  uiLink: 'https://ui.mantine.dev/',

  discordLink: 'https://discord.gg/wbH82zuWMN',
  twitterLink: 'https://twitter.com/mantinedev',

  npmLink: 'https://www.npmjs.com/org/mantine',

  discordColor: '#5865f2',
  twitterColor: '#1C8CD8',

  gitHubLinks: {
    mantine: 'https://github.com/mantinedev/mantine',
    mantineUi: 'https://github.com/mantinedev/ui.mantine.dev',
    discussions: 'https://github.com/mantinedev/mantine/discussions',
    organization: 'https://github.com/mantinedev',
    releases: 'https://github.com/mantinedev/mantine/releases',
  },
};
